import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { Feed } from "../DashBoard/partials/Feed/Feed";
import "./FeedPage.css";

const FeedPage: React.FC = () => {
  const user = useSelector((state: RootState) => state.user.user);

  return (
    <div className="feed-page">
      <Feed user={user} />
    </div>
  );
};

export default FeedPage;
